// extracted by mini-css-extract-plugin
module.exports = {"empty":"DragDropContainer_empty__2EpyI","emptyText":"DragDropContainer_emptyText__2v5Vj"};